import { render, staticRenderFns } from "./SideRail.vue?vue&type=template&id=1b3ea2f8&scoped=true"
import script from "./SideRail.vue?vue&type=script&lang=js"
export * from "./SideRail.vue?vue&type=script&lang=js"
import style0 from "./SideRail.vue?vue&type=style&index=0&id=1b3ea2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ea2f8",
  null
  
)

export default component.exports